<template>
  <div>
    <div class="cart-sum">
      <div class="cart-sum__label">
        <h3 class="title is-4 has-text-grey mb-1">
          {{ $t("orderDetails.labels.cartSum") }}
          {{ $t("orderDetails.labels.net") }}
        </h3>
      </div>
      <div class="cart-sum__value is-size-4">
        <template v-if="discountApplied">
          <s class="is-5 has-text-danger is-size-6 is-block">{{
            positionPrice.beforeDiscount.netPrice | toCents | currency }}
          </s>
        </template>
        <template>
          <div class="cart-sum__value is-5">
            <template>
              {{ positionPrice.netPrice | toCents | currency }}
            </template>
          </div>
        </template>
      </div>
    </div>
    <hr
      v-if="showTax && isBusinessCustomer"
      class="has-background-grey-light"
    />
    <div v-if="showTax && isBusinessCustomer" class="cart-sum">
      <div class="cart-sum__label"></div>
      <div class="cart-sum__value is-size-3">
        {{ positionPrice.totalPrice | toCents | currency }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { discountMixin } from "@/mixins/discountMixin";
import { calculateTaxes } from "../../../utilities/tax-calculations";

export default {
  name: "CartSum",
  mixins: [discountMixin],
  props: {
    showTax: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "positionPrice",
      "taxRate",
      "isBusinessCustomer",
      "discountApplied",
      "orderTrackingInfo",
    ]),
    // When is this actually needed?
    cartSum() {
      if (this.orderTrackingInfo.price) {
        return calculateTaxes(
          this.orderTrackingInfo.price.positionPrice,
          this.orderTrackingInfo.price.calculatedTaxes.taxRate
        );
      }
      return null;
    },
  },
};
</script>

<style scoped></style>
